import { z } from "zod";

import {
  DatePickerField,
  InputField,
  SelectField,
  TextareaField,
} from "@/features/FormCard/Fields";
import { parseToDateValue } from "@/features/FormCard/utils";

import { tsfStatusFIA } from "@/data/tsf_status";

import { EditForm } from "@/features/Edit/types.ts";
import { dateSchema } from "@/features/FormCard/utils";
import i18n from "@/i18n";

export const a7FIATimeSerieFilesEdit: EditForm = {
  table_name: "a7_fia_time_serie_files",
  fieldsNotApplyTranslation: ["type_de_fichier"],
  formSchema: z.object({
    date: z.preprocess((val) => parseToDateValue(val as string), dateSchema),
    status: z.string().optional().nullable(),
    instrument_id: z
      .preprocess(
        (val) => parseInt(val as string, 10),
        z.number().int().nullable(),
      )
      .nullable(),
    fund_name: z.string().optional().nullable(),
    key: z.string().optional().nullable(),
    error_message: z.string().optional().nullable(),
    comment: z.string().optional().nullable(),
  }),
  formBodyContent: (form, multiFieldOptions) => (
    <>
      <div className=" grid grid-cols-1 md:grid-cols-2 gap-2">
        <DatePickerField
          name="date"
          label={i18n.t("a7_fia_time_serie_files.columns.date", {
            ns: "tables",
            defaultValue: "Date",
          })}
          isRequired={true}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
        <SelectField
          name="status"
          label={i18n.t("a7_fia_time_serie_files.columns.status", {
            ns: "tables",
            defaultValue: "Statut",
          })}
          isRequired={true}
          options={tsfStatusFIA}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
      </div>
      <div className=" grid grid-cols-1 md:grid-cols-2 gap-2">
        <InputField
          name="instrument_id"
          label={i18n.t("a7_fia_time_serie_files.columns.fund_name", {
            ns: "tables",
            defaultValue: "Fonds",
          })}
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
        <InputField
          name="fund_name"
          label={i18n.t("a7_fia_time_serie_files.columns.fund_name", {
            ns: "tables",
            defaultValue: "Nom du fonds",
          })}
          fieldOptions={{ isDisabled: true }}
          variant="underlined"
          multiFieldOptions={multiFieldOptions}
          control={form.control}
        />
      </div>

      <InputField
        name="key"
        label={i18n.t("a7_fia_time_serie_files.columns.key", {
          ns: "tables",
          defaultValue: "Chemin",
        })}
        isRequired={true}
        multiFieldOptions={multiFieldOptions}
        control={form.control}
      />
      <InputField
        name="error_message"
        label={i18n.t("a7_fia_time_serie_files.columns.error_message", {
          ns: "tables",
          defaultValue: "Message d'erreur",
        })}
        multiFieldOptions={multiFieldOptions}
        control={form.control}
      />

      <TextareaField
        name="comment"
        label={i18n.t("a7_fia_time_serie_files.columns.comment", {
          ns: "tables",
          defaultValue: "Commentaire",
        })}
        multiFieldOptions={multiFieldOptions}
        control={form.control}
      />
    </>
  ),
};
